import { ReactNode } from 'react';
import styles from './index.module.scss';

/**
 * Props
 * @param children 子要素
 */
interface Props {
  children: ReactNode;
}

export const AccordionList = ({ children }: Props) => {
  return <ul className={styles.accordion__list}>{children}</ul>;
};
